module.exports = __webpack_public_path__ + "img/groupInvitation.76795c60.svg";